import i18n from "i18next";
import LangageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import {
  getCookie,
  setCookie,
  getBrowserLanguage,
} from "./core/common-service/CommonService";
import {
  getLocaleFromPath,
  getTranslationPath,
  resolveLegacyLocale,
  isSupportedLocale,
  DEFAULT_LOCALE,
} from "./config/locales";

// Migrate any legacy "uk" cookie to its modern code so returning users don't
// get stuck — LanguageDetector reads the cookie too, so a stale "uk" would
// otherwise drive the active language and 404 the translation file.
const cookieLng = getCookie("lng");
const migratedCookieLng = resolveLegacyLocale(cookieLng);
if (cookieLng && cookieLng !== migratedCookieLng) {
  setCookie("lng", migratedCookieLng);
}

// Route is the source of truth; cookie is the fallback for direct visits to /.
// The page reloads on language switch (Header.js), so reading pathname once
// at init is safe — there is no SPA navigation that bypasses this.
const activeLocale =
  getLocaleFromPath(window.location.pathname) ??
  (isSupportedLocale(migratedCookieLng) ? migratedCookieLng : DEFAULT_LOCALE);
const translationPath = getTranslationPath(activeLocale);

i18n
  .use(LangageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    debug: window.location.host.startsWith("localhost"),
    lng: activeLocale,
    fallbackLng: getBrowserLanguage() ?? "en",
    returnObjects: true,
    backend: {
      loadPath: `/locales/${translationPath}/{{ns}}.json`,
    },
  });
